import { render } from "./FloorOpenspace.vue?vue&type=template&id=4e850eff&scoped=true"
import script from "./FloorOpenspace.vue?vue&type=script&lang=js"
export * from "./FloorOpenspace.vue?vue&type=script&lang=js"

import "./FloorOpenspace.vue?vue&type=style&index=0&id=4e850eff&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e850eff"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress});
